import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBG_CUSTOM_01_Schema } from './M_TBG_CUSTOM_01_Schema';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../Hooks/apis/useDeleteMutaion';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

/** TBM 동영상/교육자료 조회 GetTbmCustomR1 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_TBG_CUSTOM_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['TBM', 'getTbmCustomR1', params],
    queryFn: () => apiRequest('post', Global.urls.TBM.getTbmCustomR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** TBM 회의 시작시간 저장 SaveTbmU1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_01_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.TBM.saveTbmU1, payload);
  }, options);
};

/** 교육현황 저장 SaveTbmStatusU1 */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_01_Schema.mapper.save2);
    return apiRequest('post1', Global.urls.TBM.saveTbmStatusU1, payload);
  }, options);
};

/** TBM 삭제 DeleteTbmD1 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (item) => {
    const payload = mapParamsBySchema(M_TBG_CUSTOM_01_Schema.mapper.delete1, item);
    return apiRequest('post', Global.urls.TBM.deleteTbmD1, payload);
  }, options);
};
